import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@perch/ui-tokens';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block mb-2 text-sm font-medium text-stone-700 dark:text-stone-300">
            {label}
            {props.required && <span className="text-primary ml-1">*</span>}
          </label>
        )}
        <input
          ref={ref}
          className={cn(
            'w-full px-3.5 py-[11px] bg-white dark:bg-stone-800 border border-stone-300 dark:border-stone-600 rounded-[10px] text-sm text-stone-900 dark:text-stone-100 placeholder:text-stone-400 dark:placeholder:text-stone-500 focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgba(255,107,53,0.1)] transition-[border-color,box-shadow]',
            error && 'border-red-500 focus:border-red-500 focus:shadow-[0_0_0_3px_rgba(239,68,68,0.1)]',
            className,
          )}
          {...props}
        />
        {helperText && !error && (
          <p className="mt-1.5 text-xs text-stone-500 dark:text-stone-400">{helperText}</p>
        )}
        {error && (
          <p className="mt-1.5 text-xs text-red-600 dark:text-red-400">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
